<template>
  <a-row style="margin: 0 -12px">
    <a-col style="padding: 0 12px" :xl="6" :lg="24" :md="24" :sm="24" :xs="24">
      <a-card title="消息模板" :bordered="false" :loading="loading">
        <a-collapse v-model="activeKey">
          <a-collapse-panel
            v-for="item in data"
            :key="item.id"
            :header="item.name"
            style="padding: 0"
          >
            <ul class="c-list">
              <li
                :class="{ active: currentItem.key == item.id + '-' + subItem.id}"
                v-for="subItem in item.children"
                :key="item.id + '-' + subItem.id"
                v-text="subItem.name"
                @click="clickSubItem(item, subItem)"
              >
                sfdsf
              </li>
            </ul>
          </a-collapse-panel>
        </a-collapse>
      </a-card>
    </a-col>
    <a-col style="padding: 0 12px" :xl="18" :lg="24" :md="24" :sm="24" :xs="24">
      <a-card
        :bordered="false"
        :title="
          currentItem.name
            ? currentItem.parentName + ' - ' + currentItem.name
            : '模板内容'
        "
        :loading="loading"
      >
        <label for="">模板内容:</label>
        <a-textarea
          style="margin-top: 15px"
          v-model="currentItem.msg"
          placeholder="请输入模板内容"
          :auto-size="{ minRows: 8, maxRows: 20 }"
        />
        <div class="footer-submit-btns">
          <a-button :disabled="!(currentItem.msg&&currentItem.itemId)" type="primary" @click="submit"
            >保存</a-button
          >
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { buildTree } from "@/utils/tree-utils";
import { listAll, update, save, getOne } from "@/services/template";
export default {
  name: "MsgTemplate",
  data() {
    return {
      activeKey: [],
      data: [],
      currentItem: {},
      loading:false,
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      let d = await listAll();
      if(d.length){
        this.activeKey = [d[0].id];
      }
      this.data = buildTree(d);
      this.loading = false;
    },
    async submit() {
      if(this.currentItem.id){
        await update(this.currentItem);
      }else{
        await save(this.currentItem);
      }
      this.$message.success("保存成功");
      this.getData();
    },
    async clickSubItem(item, subItem) {
      this.currentItem = await getOne({ itemId: item.id, orgId: subItem.id });
      if(!this.currentItem){
        this.currentItem = {
          itemId: item.id,
          orgId: subItem.id,
          msg: "",
        };
      }
      this.currentItem.name = subItem.name;
      this.currentItem.parentName = item.name;
      this.currentItem.key = item.id + "-" + subItem.id;
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>

<style lang="less" scoped>
.c-list {
  list-style: none;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
  li {
    padding: 15px 0;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
  }
  .active {
    color: @primary-color;
  }
}
</style>
